import React from "react";

import SectionMessage from "@atlaskit/section-message";
import { getJiraBaseURL } from "../../../env/stage";
import { useSelector } from "react-redux";

const isSandbox = (url) => {
  try {
    const { hostname } = new URL(url);

    // Must be an Atlassian Cloud tenant
    if (!hostname.endsWith(".atlassian.net")) {
      return false;
    }

    // Match allowed sandbox patterns
    return hostname.includes("-sandbox");
  } catch {
    return false;
  }
};

const SandBoxWarning = () => {
  const flow = useSelector((state) => state.integration.flow);

  const isSchedule = () => {
    if (flow?.trigger?.type === "SCHEDULED_TRIGGER_TYPE" && isSandbox(getJiraBaseURL())) {
      return <SectionMessage appearance="warning">This is a sandbox environment. Scheduled triggers will not run here.</SectionMessage>;
    }
  };

  return <>{isSchedule()}</>;
};
export default SandBoxWarning;
